import { render, staticRenderFns } from "./singleImg.vue?vue&type=template&id=9672728c&scoped=true&"
import script from "./singleImg.vue?vue&type=script&lang=js&"
export * from "./singleImg.vue?vue&type=script&lang=js&"
import style0 from "./singleImg.vue?vue&type=style&index=0&id=9672728c&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9672728c",
  null
  
)

export default component.exports